import { ThemeIcon, useMantineTheme } from '@mantine/core';
import type { Icon as TablerIcon, TablerIconsProps } from '@tabler/icons-react';
import { map, range } from 'lodash-es';
import { createElement } from 'react';
import SkeletonWidgetRow from './SkeletonWidgetRow';

interface IListCardProps {
	colors: [string, string];
	icons: [TablerIcon, TablerIcon];
	iconProps?: TablerIconsProps;
}

function ListCard({ colors, icons, iconProps = { size: 18 } }: IListCardProps) {
	const theme = useMantineTheme();

	// Create a new iconProps object with the color properly mapped through the theme
	const mappedIconProps = {
		...iconProps,
		color: iconProps.color
			? theme.other.getColor(iconProps.color as string)
			: undefined,
	};

	return (
		<>
			{map(range(2), (i) => (
				<SkeletonWidgetRow
					key={i}
					icon={
						<ThemeIcon color={theme.other.getColor(colors[i])} radius={24}>
							{createElement(icons[i], mappedIconProps)}
						</ThemeIcon>
					}
				/>
			))}
		</>
	);
}

export default ListCard;
